import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { ContactItem } from './components/contact-item';
import { useGetEnrichmentItems } from './hooks/use-get-enrichment-items';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactEnrichmentOptionsProps as Props } from './types';

export const ContactEnrichmentOptions = memo(({ className }: Props) => {
  const { items } = useGetEnrichmentItems();

  return (
    <Styled.Wrapper
      className={classnames('ContactEnrichmentOptions', className)}
      sx={SX.root}
      gap={1}
    >
      {items.map((i) => (
        <ContactItem key={i.title} item={i} />
      ))}
    </Styled.Wrapper>
  );
});

ContactEnrichmentOptions.displayName = 'ContactEnrichmentOptions';
